export default __webpack_public_path__ + "static/Toilet-0119da60607e29fde8c78739c146e248.png";